import { render, staticRenderFns } from "./ImgCode.vue?vue&type=template&id=032281e5&scoped=true&"
import script from "./ImgCode.vue?vue&type=script&lang=js&"
export * from "./ImgCode.vue?vue&type=script&lang=js&"
import style0 from "./ImgCode.vue?vue&type=style&index=0&id=032281e5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032281e5",
  null
  
)

export default component.exports